import variables from "../variables";
import is from "is_js";
import {$dom} from "./dom";
import {bsTargetAttr} from "../pages/utils/variables";

const {classNames, metaNames, metricsAttr, choicesOptions, searchTypes} = variables;

export function warn(message, locationName) {
    if (variables.debugLogs) console.warn(message + `. Warning source - ${locationName}`)
}

export function toDashesCase(string) {
    return  string.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
}

export function toThousand(num) {
    return num
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function toCamelCase(string) {
    return string.replace( /-([a-z])/g, function( _all, letter ) {
        return letter.toUpperCase();
    });
}

export function isElement(target){
    return (
        typeof HTMLElement === 'object' ? target instanceof HTMLElement :
            target && typeof target === 'object' && target !== null && target.nodeType === 1 && typeof target.nodeName === 'string'
    );
}

export function isNode(target){
    return (
        typeof Node === "object" ? target instanceof Node :
            target && typeof target === "object" && typeof target.nodeType === "number" && typeof target.nodeName==="string"
    );
}

export function filterStringArgs(targets) {
    return targets.toString().split(/[\s,]+/).filter(e => e.length)
}

export function optimizeTarget(target) {
    return (is.not.array(target) && !isElement(target) && target !== window && target !== document)
        ? document.querySelector(target)
        : target;
}

export function preventDefault(event) {
    (event.originalEvent || event).preventDefault();
    return event;
}

export function loop(arr, cb) {
    if (is.not.array(arr) || is.not.function(cb)) return;

    for (let i = 0; i < arr.length; i++) {
        cb.call(arr[i], arr[i], i)
    }
}

export function forIn(obj, cb) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            cb.call(obj[key], key, obj[key])
        }
    }
}

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; //Максимум и минимум включаются
}

export function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}

export function generateId(usePostfix = true) {

    const postfix = '--' + getRandomInt(0, 10000);

    return Math.random().toString(36).substr(2, 9) + (usePostfix ? postfix : '');
}

export function addZero(val) {
    return ('0' + val).slice(-2);
}

const support = (function () {
    if (!window.DOMParser) return false;
    const parser = new DOMParser();
    try {
        parser.parseFromString('x', 'text/html');
    } catch(err) {
        return false;
    }
    return true;
})();

export function stringToHTML(str) {

    // If DOMParser is supported, use it
    if (support) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(str, 'text/html');
        return doc.body.firstElementChild;
    }

    // Otherwise, fallback to old-school method
    const dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;

}

export function createIcon(name, asHtml) {

    if (!window.currentPage || !window.currentPage.assetsPath) return null;

    const icon = `<svg class="svg-icon"><use xlink:href="${window.currentPage.assetsPath}/sprite.svg#${name}"></use></svg>`

    return asHtml ? stringToHTML(icon) : icon;
}

export function getMeta(name) {
    const el = $dom.get(`meta[name=${name}]`);

    if (isElement(el))
        return $dom.attr(el, 'content')

    return null
}

export function textFormTime(time) {
    let
        minutes = '' + Math.floor(time / 60),
        seconds = '' + time % 60
    ;

    seconds = seconds.length === 1 ? '0' + seconds : seconds;

    return minutes + ':' + seconds;
}

export function formDataToObj(formData) {
    let result = {};

    for (const pair of formData.entries()) {
        const [key, value] = pair;

        if (value) {
            result[key] = value
        }
    }

    return result
}

export function isHidden(el) {
    return (el.offsetParent === null)
}

export const getChoice = selector => {
    const {select, searchSelect} = window.currentPage.components;
    let check = typeof selector === 'string' ? $dom.exist(selector) : isElement(selector);

    if (check) {
        const selectEl = typeof selector === 'string' ? $dom.get(selector) : selector;
        const fieldId = selectEl.getAttribute('id');
        let choice;

        if (fieldId) {
            if ($dom.hasClass(selectEl, classNames.searchSelect)) {
                if (searchSelect && searchSelect.fields[fieldId])
                    choice = searchSelect.fields[fieldId].instance;
            } else {
                choice = select.fields[fieldId]
            }
        }

        if (!choice) return null;

        return choice
    }

    return null;
}

export function resetChoice(choice, fillExisting = false) {
    let items = [];

    if (!choice._isSelectMultipleElement) {
        items.push({value: '', label: choice._placeholderValue, placeholder: true})
    }

    if (fillExisting) {
        const defineSource = ({_currentState, config}) => {
            let result = _currentState.choices.length > 0
                ? _currentState.choices
                : config.choices;

            if (choice._isSelectMultipleElement)
                result = result.filter(({value}) => Boolean(value));

            return result
        }



        items = [...defineSource(choice)]
    }

    choice
        .setChoices(items, 'value', 'label', true)
        .setChoiceByValue('');
}

export function getActiveTabNav(controlSelector) {
    const activeOption = $dom.getAll(controlSelector)
        .filter(opt => Boolean(opt.getAttribute(bsTargetAttr)))
        .find(opt => $dom.hasClass(opt, 'active'));

    return activeOption || null
}

export function prepareFileFormData(file) {
    const fd = new FormData();
    fd.append('file', file, file.name);
    fd.append('_token', getMeta(metaNames.token));

    return fd
}

export function prepareFormData(form) {
    if (!form) return null;

    const fd = new FormData(form);
    fd.append('_token', getMeta(metaNames.token));

    return fd;
}

export function isPromise(f) {
    return typeof f === 'object' && typeof f.then === 'function';
}

export function isAdmin() {
    return getMeta(metaNames.isAdmin) === 'true'
}

export function declensionOfNumbers(value, words) {
    value = Math.abs(value) % 100;
    const num = value % 10;

    if(value > 10 && value < 20) return words[2];
    if(num > 1 && num < 5) return words[1];
    if(num === 1) return words[0];
    return words[2];
}

export function sendMetricsFromEl(element) {
    const {metricsSend, currentPage} = window;

    const payloadAttr = $dom.attr(element, metricsAttr);

    if (payloadAttr) {
        try {
            const payload = JSON.parse(payloadAttr);

            (metricsSend && payload) && metricsSend(payload);
        } catch (e) {
            currentPage
                ?.toast
                .show(e?.toString(), 'danger')
        }
    }
}

export function getChoiceScrollEl(targetChoiceId) {
    try {
        const {searchSelect} = window.currentPage.components;
        if (!searchSelect) return null;

        return $dom.get(
            `.${choicesOptions.classNames.listDropdown} .${choicesOptions.classNames.list}`,
            searchSelect.getContainer(searchSelect.fields[targetChoiceId]?.instance)
        )
    } catch (e) {console.error(e)}
}

export function updateCitiesByPhoneChange(intlTelInputSelector, choiceSelectId) {
    try {
        const {searchSelect} = window.currentPage.components;
        if (!searchSelect) return null;

        const intlTelInput = $dom.get(intlTelInputSelector)?.intlTel;
        if (!intlTelInput) return;
        const countryData = intlTelInput?.getSelectedCountryData();
        if (!countryData) return;
        const cityChoice = getChoice('#'+choiceSelectId);

        resetChoice(cityChoice);

        searchSelect
            .updateField(choiceSelectId, {alfa: countryData?.iso2, page: 1})
            .makeRequest(searchTypes.cities, choiceSelectId)
            .then(results => {
                cityChoice.setChoices(results, 'value', 'label', true);
                searchSelect.updateField(choiceSelectId, {page: 2});

                const listElement = getChoiceScrollEl(choiceSelectId);

                listElement && (listElement.scrollTop = 0);
            })
        ;
    } catch (e) {console.error(e)}
}
export function respondToVisibility(element, callback) {
	var observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
		    callback(entry.intersectionRatio > 0);
		});
	}, {
		root: document.documentElement
	});

	observer.observe(element);
};